export function getIdsArray(input: string): string[] {
  return input
    .trim()
    .replace(/\s/g, "") // whitespace
    .replace(/,+$/, "") // trailing commas
    .replace(/,\s+/, "") // commas with whitespace
    .replace(/,,/, ",") // empty commas
    .split(",");
}

export function isValidJobID(input: string): boolean {
  return /^[a-fA-F0-9]{24}$/.test(input);
}

export function isValidCreativeID(input: string): boolean {
  return /^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$/.test(input);
}

export function isValidNetworkID(input: string): boolean {
  return /^\d{5,6}$/.test(input);
}

export function isValidCreativeRenditionID(input: string): boolean {
  return /^\d+$/.test(input);
}

export function isValidSource(input: string): boolean {
  if (input.length <= 2) {
    return false;
  }

  try {
    new RegExp(input);
    return true;
  } catch {
    return false;
  }
}

export function isValidDateRange(start?: Date, end?: Date): boolean {
  return start != null && end != null && start.getTime() <= end.getTime() && start.getTime() <= Date.now();
}
